export default __webpack_public_path__ + "static/media/arrow-right-black.7c34ec64.svg";